const en = {
  next: "Next",
  prev: "Previous",
  menu:{
    home: "Home",
    about: "About me",
    contact: "Contact"
  },
  home: {
    title: "Web Develop er, 3D modeler, pixel artist & game developer",
    description:
      "Hi my name is Raúl, I consider myself a polymath, with a strong enthusiasm for learning about new areas",
    recent: { title: "RECENT ENTRIES" },
    areas: {
      title: "SOME OF MY WORK AREAS",
      tools_t: "Tools",
      projects_t: "Projects",
      more: "More",
      web: {
        title: "Web Development",
        tools:
          "<strong>NodeJS, React, Firebase, Git, Visual studio code</strong>, PHP, Wordpress, MySQL, MongoDB",
        projects: "This website, Konfort eshop, ...",
      },
      model3d: {
        title: "3D Modeling",
        tools: "<strong>Blender</strong>, Maya, Mudbox, MagicaVoxel.",
        projects: "Peter Sloth, Pacific Trail (Animals)...",
      },
      pixel: {
        title: "Pixel Art",
        tools: "<strong>Aseprite</strong>, Gimp, Krita, Inkscape, MagicaVoxel.",
        projects: "Mandragora (Agartota), Cervates, Octobit 2020, ...",
      },
      game: {
        title: "Game Development",
        tools:
          "<strong>Unity 3D, Git, Visual studio code</strong>, PlayCanvas(WIP)",
        projects:
          "Pacific Trail (AR), Agartota Domain - Beta (collab Héctor Salas), A-tempus (VN WIP), Color Witch (WIP), ...",
      },
    },
    contact: {
      title: "Are you interested in working with me?",
      talk: "Talk to me about it",
    },
  },
  blog: {
    search: "Search",
  },
  about: {
    title: "About me",
    birthday: "Birthday",
    span: "Spanish",
    eng: "English",
    span_lvl: "Native",
    eng_lvl: " Upper Intermediate (B2)",
    description: "I am a polymath, self-taught, responsible and creative, with great pleasure for learning about different areas. I have a good set of skills in the area of web development, I also have knowledge in digital design, image edition, video edition, 3D modeling and 3D animation.The more knowledge I acquire, the more comfortable I feel.",
    education: "Education",
    ucr: "University of Costa Rica",
    bach_itm: "Computer Science and Multimedia Technologies bachelor degree  (March 2014-May 2018)",
    lic_itm: "Computer Science and Multimedia Technologies licenciate degree  (January 2018-February 2021)",
    work_exp: "Work Expirience",
    leaf_job: "Full-stack developer (August 2017-December 2018) Costa Rica, San José, Mata Redonda.",
    skills: "Skills",
    programming_langs: "Programming languages",
    for_unity: "for Unity3D",
    tecnologies: "Technologies / Frameworks / Tools",
    db: "Databases",
    others: "Others",
    agile: "Agile Methodologies",
    ux: "UX Design",
    model3d: "3D Modeling",
    design: "Graphic Design",
    image_ed: "Image edition",
    video_ed: "Video edition",
    animate3d: "3D animation",
    soft_skills: "Soft skills",
    soft_desc: "Always in search of new knowledge, self-taught, enthusiastic about new tasks and the implementation of new tools, good teamwork, friendly, good follow-up of instructions and in search of providing new solutions if required.",
    hobbies: "Hobbies",
    videogames: "Videogames",
    read: "Reading",
    write: "Writing",
    agriculture: "Agriculture",
    dialogue: "Dialogue"
  },
  contact: {
    title: "Contact",
  },
};

export default en;
